import { render, staticRenderFns } from "./CompensationView.vue?vue&type=template&id=5acfcbd4"
import script from "./CompensationView.vue?vue&type=script&lang=js"
export * from "./CompensationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports